import { PageHero } from "../components/site/PageHero";
import { Services } from "../components/site/Services";
import { Process } from "../components/site/Process";
import { CTABand } from "../components/site/CTABand";
import { Reveal } from "../components/site/Reveal";
import { IMAGES } from "../data/content";

export default function ServicesPage() {
  return (
    <>
      <PageHero
        eyebrow="Our Services"
        title="Cooling & heating, done right."
        subtitle="From sales and installation to service, repairs, electrical and walk-in coolers — for homes and businesses across Florida."
      />

      <section className="surface-light py-16 lg:py-20">
        <div className="mx-auto w-[92%] max-w-[1280px]">
          <Reveal>
            <div className="relative h-[260px] lg:h-[380px] overflow-hidden rounded-2xl border border-fc-ink/10 shadow-[0_30px_70px_rgba(11,44,92,0.15)]">
              <img src={IMAGES.technician} alt="Condensate drain service on an air handler installed by F&C" loading="lazy" decoding="async" className="h-full w-full object-cover" />
              <div className="absolute inset-0 bg-gradient-to-r from-fc-navy/85 via-fc-navy/40 to-transparent" />
              <div className="absolute inset-0 flex items-center">
                <div className="px-8 lg:px-14 max-w-xl text-white">
                  <div className="font-mono text-[12px] font-bold uppercase tracking-[0.25em] text-fc-orange">Trusted Local Team</div>
                  <h2 className="mt-3 font-display text-3xl md:text-5xl font-bold tracking-tight leading-[0.98]">
                    Professional service you can count on.
                  </h2>
                </div>
              </div>
            </div>
          </Reveal>
        </div>
      </section>

      <Services />
      <Process />
      <CTABand />
    </>
  );
}
